import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardCheck, ShieldAlert, Snowflake } from "lucide-react";
import { api } from "@/lib/api";

/** Dashboard roll-up of every open storm / freeze checklist across the portfolio. */
export function StormPlaybooks() {
  const [books, setBooks] = useState([]);
  useEffect(() => {
    const load = () => api.get("/weather/playbooks")
      .then(({ data }) => setBooks(data))
      .catch(() => setBooks([]));
    load();
    const t = setInterval(load, 300000);
    return () => clearInterval(t);
  }, []);

  if (!books.length) return null;
  return (
    <section data-testid="storm-playbooks" className="rounded-xl border border-border bg-card p-5">
      <h2 className="flex items-center gap-2 text-base md:text-lg font-display font-semibold text-royal-deep">
        <ClipboardCheck className="h-4 w-4 text-royal" /> Weather checklists
        <span className="text-xs font-normal text-muted-foreground">
          {books.length} open
        </span>
      </h2>
      <div className="mt-3 grid gap-2.5 sm:grid-cols-2 lg:grid-cols-3">
        {books.map((b) => {
          const done = b.items.filter((i) => i.done).length;
          return (
            <Link key={b._id} to={`/properties/${b.property_id}`}
                  data-testid={`playbook-card-${b._id}`}
                  className={`block rounded-lg border px-3.5 py-2.5 transition-transform duration-200 hover:scale-[1.02] ${
                    b.kind === "freeze" ? "border-sky-300 bg-sky-50" : "border-red-300 bg-red-50"}`}>
              <p className="flex items-center gap-1.5 text-sm font-semibold text-royal-deep">
                {b.kind === "freeze" ? <Snowflake className="h-3.5 w-3.5 text-sky-600" />
                  : <ShieldAlert className="h-3.5 w-3.5 text-red-600" />}
                {b.property_name}
              </p>
              <p className="text-xs text-muted-foreground">{b.title}</p>
              <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-white">
                <div className="h-full rounded-full bg-royal transition-all duration-300"
                     style={{ width: `${Math.round((done / b.items.length) * 100)}%` }} />
              </div>
              <p className="mt-1 text-[11px] uppercase tracking-wider text-muted-foreground">
                {done}/{b.items.length} done · {b.event}
              </p>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export default StormPlaybooks;
